var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_introduction"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('a', {
    attrs: {
      "href": _vm.bannerItem.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bannerItem.mediaCode,
      "width": "1400",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-zx fr"
  }, [_c('a', {
    staticClass: "a-btn-zx",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopAskAndFavoriteShow()
      }
    }
  }, [_vm._v("咨询／收藏"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zx-drop-box none",
    on: {
      "mouseleave": function($event) {
        _vm.shopAskAndFavoriteHidden()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-2"
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "a-btn-scbd ml10",
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "shop-tabbox-1 shop-jp-tj"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bd bd-2"
  }, [_c('div', {
    staticClass: "shop-qyjs-box"
  }, [_c('dl', [_c('dt', [_vm._v("店铺信息")]), _vm._v(" "), _c('dd', [_vm._v("所在地区： " + _vm._s(_vm.shopBo.province) + _vm._s(_vm.shopBo.city) + _vm._s(_vm.shopBo.district))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("联系我们")]), _vm._v(" "), _c('dd', [_vm._v("联系客服："), _c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": _vm.shopBo.qq
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")])]), _vm._v(" "), _c('dd', [_vm._v("收藏店铺："), _c('a', {
    staticClass: "a-btn-scbd",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopDesc",
    domProps: {
      "innerHTML": _vm._s(_vm.shopBo.shopDesc)
    }
  }, [_vm._v("\n\t         \t\t" + _vm._s(_vm.shopBo.shopDesc) + "\n\t         \t")])])])])]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hq-shop-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("企业介绍")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-1"
  }, [_c('i', {
    staticClass: "dp-ico-arrw"
  }), _vm._v(" "), _c('p', [_vm._v("店铺等级："), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  })]), _vm._v(" "), _c('p', [_vm._v("信用等级： v6 "), _c('span', {
    staticClass: "dp-ico-xydj"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd hd-2"
  }, [_c('ul', [_c('li', {
    staticClass: "hover mb20"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("企业介绍")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_vm._v("工商执照："), _c('img', {
    staticClass: "v_mid",
    attrs: {
      "src": require("../../../static/images/ico-gs.jpg"),
      "width": "18",
      "height": "20"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("店铺服务")]), _vm._v(" "), _c('dd', [_c('img', {
    staticClass: "mr8",
    attrs: {
      "src": require("../../../static/images/ico-fwbz-1.png"),
      "width": "68",
      "height": "68"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mr8",
    attrs: {
      "src": require("../../../static/images/ico-fwbz-2.png"),
      "width": "68",
      "height": "68"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mr8",
    attrs: {
      "src": require("../../../static/images/ico-fwbz-3.png"),
      "width": "68",
      "height": "68"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-391ff9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/shop/shop_introduction.vue
// module id = 586K
// module chunks = 1